import * as sup from "superstruct";

import { createResourceStruct } from "@/modules/api/utils/jsonApiStructs";

import { handbookItemIdentifierStruct } from "./handbooksIdentifierStruct";

const handbookItemResourceStruct = createResourceStruct({
  identifier: handbookItemIdentifierStruct,
  attributes: sup.object({
    name: sup.string(),
  }),
  meta: sup.object({
    usedInTutorialCount: sup.number(),
  }),
});

export const handbooksResourceStruct = sup.array(handbookItemResourceStruct);
